module.exports = __webpack_public_path__ + "img/Flag_of_Ireland.8add6c11.svg";